import { gql } from '@apollo/client';

const LOGIN_AS_CLINIC_MUTATION = gql`
  mutation loginAsClinic($input: LoginAsClinicInput) {
    loginAsClinic(input: $input) {
      isSuccess
      message
      authorizedToken
    }
  }
`;

export default LOGIN_AS_CLINIC_MUTATION;
